module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"LA Vintage Map","short_name":"LA Vintage Map","start_url":"/","background_color":"#FF3C5C","theme_color":"#FF3C5C","display":"minimal-ui","icon":"src/images/logo-la.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"5082bc1d33fe6b61089dd5564297eec1"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
